import React, {createContext} from 'react';
const ProductContext = createContext(null);
export {ProductContext};